import { routeTitles } from "constants";
import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";

export const getRouteTitle = (pathname) => {
  for (const route in routeTitles) {
    const match = matchPath({ path: route, end: true }, pathname);

    if (match) {
      return routeTitles[route];
    }
  }

  return "شاین";
};

const PageTitleHandler = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = getRouteTitle(pathname);
    document.title = title;
  }, [pathname]);

  return null;
};

export default PageTitleHandler;
